import { render, staticRenderFns } from "./DailyApproveMessage.vue?vue&type=template&id=495f8a19&scoped=true"
import script from "./DailyApproveMessage.vue?vue&type=script&lang=js"
export * from "./DailyApproveMessage.vue?vue&type=script&lang=js"
import style0 from "./DailyApproveMessage.vue?vue&type=style&index=0&id=495f8a19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f8a19",
  null
  
)

export default component.exports